import React from 'react';
import { getTeamUrl } from '../../../utils/routes';
import { getProxyUrl } from '../../../utils/image';

function TeamsTableRow({ team, i, orderBy }) {
  const getTeamLogo = () => {
    return team?.logoImage
      ? getProxyUrl(team?.logoImage, 50, 50)
      : '/wp-content/themes/sef-leagues/images/generic-team.png';
  };

  return (
    <div className="stats-table__row">
      <div className="col-1 text-center heading-stats-name">{i}</div>
      <a
        href={getTeamUrl(team?.abbrv)}
        className="col-8 col-md-7 name-with-team-logo"
      >
        <div className="name-with-team-logo name-with-team-logo">
          <img alt="teamlogo" src={getTeamLogo()} />
          <span className="d-none d-sm-inline-block text-color-primary-white">
            {team?.name}
          </span>
          <span className="d-inline-block d-sm-none text-color-primary-white">
            {team?.name}
          </span>
        </div>
      </a>
      <div className="col-auto col-md-2 d-none d-md-block text-center">
        {team?.matchesPlayed}
      </div>
      <div className="col-3 col-md-2 text-center stats-font-larger">
        {team[orderBy]}
      </div>
    </div>
  );
}
export default TeamsTableRow;
